import React, {useState, useEffect} from 'react'
import NavBar from '../components/NavBar'
import AppNavBar from '../components/NavBar'



export default function About(props){

    return(

        <div>
            <h1> About page</h1>
        </div>
    )

}